import '../stylesheets/login.scss';
require("@rails/actiontext");
require("@rails/activestorage").start();

import "channels"


import jQuery from "jquery";
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;
require('bootstrap/dist/js/bootstrap');
require('popper.js/dist/popper.min');




import Turbolinks from 'turbolinks'
import "controllers"

import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
window.Swal = Swal;
Turbolinks.start();


